export default {"src":"/_next/static/media/return.4846a19b.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};